import css from "./index.module.css";
import AddIcon from '@mui/icons-material/Add';
import Header from "../../../components/Header";
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import MissionPrequisiteIcon from "../../../components/MissionPrequisiteIcon";

import Ir from "../../../assets/buildingIcons/Ir.png"
import Led from "../../../assets/buildingIcons/Led.png"
import Nano from "../../../assets/buildingIcons/Nano.png"
import oled from "../../../assets/buildingIcons/oled.png"
import LTPin from "../../../assets/buildingIcons/LTPin.png"
import Kugel from "../../../assets/buildingIcons/Kugel.png"
import Räder from "../../../assets/buildingIcons/Räder.png"
import Würfel from "../../../assets/buildingIcons/Würfel.png"
import Taster from "../../../assets/buildingIcons/Taster.png"
import hbrücke from "../../../assets/buildingIcons/hbrücke.png"
import LedRing from "../../../assets/buildingIcons/LedRing.png"
import DcMotor from "../../../assets/buildingIcons/DcMotor.png"
import ledAmpel from "../../../assets/buildingIcons/ledAmpel.png"
import Batterie from "../../../assets/buildingIcons/Batterie.png"
import Drehpotie from "../../../assets/buildingIcons/Drehpotie.png"
import Fehelend0 from "../../../assets/buildingIcons/Fehelend0.png"
import Fehelend1 from "../../../assets/buildingIcons/Fehelend1.png"
import Lichtsensor from "../../../assets/buildingIcons/Lichtsensor.png"
import Ultraschall from "../../../assets/buildingIcons/Ultraschall.png"
import Minibreadboard from "../../../assets/buildingIcons/Minibreadboard.png"
import lAbstandshalter from "../../../assets/buildingIcons/lAbstandshalter.png"

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/fetch";

/**
 * Displays Cheatsheet page.
 * @param {String} studentId 64 character uuid of given student
 */
const Cheatsheet = ({studentId}) => {
  const [selected, setSelected] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Programmierung");
  const [selectedPage, setSelectedPage] = useState(1);
  const [studentToMission, setStudentToMission] = useState(null);
  const [data, setData] = useState([]);
  const [dataImages, setDataImages] = useState([]);
  const [dataImages2, setDataImages2] = useState([]);
  
  useEffect(()=> {
    getData("/api/studentToMission").then(data => setStudentToMission(data.filter(f => f.student_id === studentId)));
    getData("/api/missions").then(data => {
      let temp = [
        {name: "if-Anweisung", ref: [data[8]]}, 
        {name: "for-Schleifen", ref: [data[4]]}, 
        {name: "Motoren ansteuern", ref: [data[2]]}, 
        {name: "serieller Monitor", ref: [data[7]]}, 
        {name: "analog Read()", ref: [data[1]]}, 
        {name: "digital Read()", ref: [data[2]]}, 
        {name: "Arrays", ref: [data[10]]}, 
        {name: "Servos", ref: [data[2]]}, 
        {name: "Ultraschallsensor", ref: [data[6]]},
        {name: "Infrarotsensor", ref: [data[10]]}, 
        {name: "Lichtsensor", ref: [data[11]]}
      ];
        setData(temp);
      let tempImages = [
        {img: Ir,             ref: [data[10]],  name: "Infrarotsensor"},
        {img: Lichtsensor,    ref: [data[11]],  name: "Lichtsensor"},
        {img: Ultraschall,    ref: [data[6]],   name: "Ultraschallsensor"},
        {img: Fehelend0,      ref: [],          name: "-/-"},
        {img: Fehelend1,      ref: [],          name: "-/-"},
        {img: Batterie,       ref: [data[2]],   name: "9V Batterie"},
        {img: Minibreadboard, ref: [data[0]],   name: "Minibreadboard"},
        {img: Nano,           ref: [data[0]],   name: "Arduino Nano"},
        {img: Drehpotie,      ref: [data[9]],   name: "Drehpotie"},
        {img: Taster,         ref: [data[8]],   name: "Taster"},
        {img: LedRing,        ref: [data[4]],   name: "LedRing"},
        {img: Led,            ref: [data[0]],   name: "Led"},
        {img: oled,           ref: [data[5]],   name: "Oled Display"},
        {img: hbrücke,        ref: [data[2]],   name: "H-Brücke"},
        {img: ledAmpel,       ref: [data[0]],   name: "ledAmpel"},
      ];
      setDataImages(tempImages);
      let tempImages2 = [
        {img: Würfel,         ref: [],    name: "Würfel"},
        {img: LTPin,          ref: [],  name: "Lego Technik Pin"},
        {img: Kugel,          ref: [],  name: "3. Rad"},
        {img: lAbstandshalter,ref: [],  name: "L-Abstandshalter"},
        {img: Räder,          ref: [data[2]],  name: "Räder"},
        {img: DcMotor,        ref: [data[1]],  name: "DC-Motor"},
      ];
      setDataImages2(tempImages2);
    });
    
  }, [studentId]);

  const handlePage = (action) => {
    if((selectedPage === 1 && action === 1) || (selectedPage === 1 && action === -1)) {
      setSelectedPage(2);
    } else {
      setSelectedPage(1);
    }
  }

  return (
    <div className={css.page}>
      <Header isTeacher={false} nav={"Cheatsheet"} />
      <div className={css.container}>
        <div className={css.data}>
          <div className={css.tab}>
            <span className={selectedTab === "Programmierung" ? css.selectedTab : ""} onClick={() => {setSelectedTab("Programmierung"); setSelected(null)}}>Programmierung</span>
            <span className={selectedTab === "Bilder" ? css.selectedTab : ""} onClick={() => {setSelectedTab("Bilder"); setSelected(null)}}>Bauteile {selectedTab === "Bilder" && "Seite"} </span>
            {selectedTab === "Bilder" && 
              <div className={css.tabPage}>
                
                  <span className={css.selectedTab}> {selectedPage}/2</span>
                  <div>
                    {selectedPage === 1 && <AddIcon onClick={() => handlePage(-1)}/>}
                    {selectedPage === 2 && <RemoveIcon  onClick={() => handlePage(-1)}/>}
                  </div>
              </div>
            }
          </div>
          {selectedTab === "Programmierung" &&
            (
              <div className={css.text}>
                {data.map((element, index) => {
                  return (
                    <div key={element.name} className={css.card} onClick={() => setSelected(index)}>
                      {element.name}
                    </div>
                  )
                })}
              </div>
            )
          }
          {selectedTab === "Bilder" && <Imagegallery data={selectedPage === 1 ? dataImages : dataImages2} setSelected={setSelected}/> }
          
        </div>
        {window.innerWidth <= 1400 ? <ArrowDownwardIcon style={{fontSize: 60}}/> : <ArrowForwardIcon style={{fontSize: 60}}/>}
        <div className={css.content}>
          {selectedTab === "Programmierung" && selected != null ? 
            <PrequisiteList data={data[selected]} studentToMission={studentToMission} studentId={studentId}/> :
            <PrequisiteList data={selectedPage === 1 ? dataImages[selected] : dataImages2[selected]} studentToMission={studentToMission} studentId={studentId}/>
          }
        </div>
      </div>
    </div>
  )
}

/**
 * Renders the list of missions that use the given dataelement
 * @param {Array} data
 * @param {Array} studentToMission
 * @param {String} studentId 
 */
const PrequisiteList = ({data, studentToMission, studentId}) => {
  return (
    data?.ref.map(element => {
      const isCompleted = studentToMission?.filter(e => e.mission_id === element.id && e.completed === true).length > 0;
      const isUnlocked = studentToMission?.filter(e => e.mission_id === element.prequisite_id && e.completed === true).length > 0 || element.prequisite_id === "";
      return (
        <Link key={"missionprequisiteIconLink" + element.id} to={isUnlocked ? `/student/${studentId}/mission/${element.id}` : `/student/${studentId}/missions`}>
          <MissionPrequisiteIcon missionName={element.number} completed={isCompleted} unlocked={isUnlocked}/>
        </Link>
      ) 
    })
  )
}

const Imagegallery = ({data, setSelected}) => {
  return (
    <div className={css.images}>
      {data.map((e, i) => {
        return (
          <div key={"img_" + e.name + i}>
            <img src={e.img} alt={e.name} onClick={() => setSelected(i)} className={e.name === "-/-" ? css.notavailable : ""}/>
            <span onClick={() => setSelected(i)}>{e.name}</span>
          </div>
        )
      })}
    </div>
  )
}

export default Cheatsheet;